export const TOKENS = {
  primary: "#861b68",
  primaryDark: "#6c1554",
  primaryAlt: "#a32480",
  bg: "#ffffff",
  ink: "#000000",
  border: "#eeeeee",
  inputBorder: "#d9d9d9",
  muted: "#6b6b6b",
  success: "#1c6b3f",
  successBg: "#f0f8f3",
  warn: "#8a5a00",
  warnBg: "#fdf6e8",
  danger: "#9c1c1c",
  dangerBg: "#fbeeee",
  neutralBg: "#faf8f9",
};

export const DAY_MS = 24 * 60 * 60 * 1000;
export const SEVEN_DAYS_MS = 7 * DAY_MS;
export const MAX_PROMPTS_PER_SESSION = 5;
export const RECEIVER_CHARGE_AMOUNT = "₹499 (mock unresolved-request charge)";

export const STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
  EXPIRED: "expired",
};

export const STATUS_LABELS = {
  [STATUS.PENDING]: "Pending",
  [STATUS.ACCEPTED]: "Accepted",
  [STATUS.REJECTED]: "Rejected",
  [STATUS.EXPIRED]: "Expired",
};

export const CURRENT_USER = {
  id: "you",
  name: "John Doe",
  designation: "Founder",
  company: "Doe Ventures",
  location: "New Delhi",
};

export const MEMBERS = [
  {
    id: 1,
    name: "Priya Sharma",
    designation: "Hotel Manager",
    company: "The Grand Palace",
    location: "New Delhi",
    description: "Handles hotel partnerships and group business for corporate and social bookings.",
  },
  {
    id: 2,
    name: "Rohit Verma",
    designation: "Business Development Manager",
    company: "XYZ Solutions",
    location: "Mumbai",
    description: "Works with business partnerships, vendor onboarding and client relationships.",
  },
  {
    id: 3,
    name: "Ananya Iyer",
    designation: "Events Director",
    company: "Iyer & Co. Events",
    location: "Bengaluru",
    description: "Plans and manages large-scale corporate and private events across South India.",
  },
  {
    id: 4,
    name: "Karan Mehta",
    designation: "Regional Sales Head",
    company: "Meridian Foods",
    location: "Pune",
    description: "Leads distribution partnerships for hospitality and retail accounts.",
  },
  {
    id: 5,
    name: "Simran Kaur",
    designation: "Venue Operations Lead",
    company: "Skyline Banquets",
    location: "Chandigarh",
    description: "Coordinates venue availability, group bookings and long-term partnerships.",
  },
  {
    id: 6,
    name: "Arjun Nair",
    designation: "Partnerships Manager",
    company: "Coastal Retreats",
    location: "Kochi",
    description: "Builds partner networks for boutique hospitality and travel packages.",
  },
];

export const AI_FOLLOWUPS = [
  "Thank you. I've noted that. Could you tell me more about the timeline you're working with?",
  "Understood. What quantity or scale should the member expect for this request?",
  "Good to know. Is there a specific location or venue that matters for this request?",
  "Noted. What outcome would you consider a successful result of this request?",
  "Thank you. I have enough context for now. I'll include everything you've shared in the summary for the member to review.",
];

export const SUMMARY_SEED = "No conversation has taken place yet for this day.";
